import { useTranslation } from "react-i18next";

import { Select } from "@/components/shared/select";

import { ALLOWED_ICON_NAMES, Icon } from "@/components/shared/icon";

interface IconPickerProps {
  value?: string | null;
  onChange: (name: string) => void;
}

/**
 * Ikonka tanlash — faqat ruxsat etilgan ro'yxatdan.
 *
 * Ro'yxat `@/components/shared/icon` dagi aniq allow-list'dan keladi:
 * `lucide-react/dynamic` reyestri emas, ya'ni build'ga 1900 ta ikonka
 * tortilmaydi va backend saqlagan noma'lum nom jimgina fallback'ga tushadi.
 */
export const IconPicker = ({ value, onChange }: IconPickerProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <span className="border-border bg-muted text-muted-foreground grid size-9 shrink-0 place-items-center rounded-lg border">
        <Icon name={value} fallback="shapes" className="size-4" />
      </span>
      <Select
        className="flex-1"
        value={value ?? ""}
        onValueChange={onChange}
        placeholder={t("CATALOG.ICON_PLACEHOLDER")}
        options={ALLOWED_ICON_NAMES.map(name => ({ value: name, label: name }))}
      />
    </div>
  );
};
